export enum Volume {
    mm3 = 1e-9,
    cm3 = 1e-6,
    m3 = 1,
    km3 = 1e9,
    litros = 0.001,
    galoes = 0.00378541,
    pesCubicos = 0.0283168,
}